<template>
  <footer>
    <div class="container">
      <div class="content">
        <span v-if="data.language.list.length > 1"><ChangeLanguage /></span>
        <span>© {{ year }} CSLobby.gg</span>
        <span>{{ content('copyright') }}</span>
        <span
          ><router-link to="/staff">{{ content('staff') }}</router-link></span
        >
        <span
          ><router-link to="/cookies">{{ content('cookies') }}</router-link></span
        >
        <span
          ><router-link to="/gdpr">{{ content('gdpr') }}</router-link></span
        >
      </div>
    </div>
  </footer>
</template>

<script>
import ChangeLanguage from '@/components/core/footer/ChangeLanguage.vue';
import dataStore from '@/helpers/data';
import language from '@/helpers/language';
export default {
  name: 'ComponentCoreFooter',
  components: {
    ChangeLanguage,
  },
  computed: {
    data() {
      return dataStore.getter(this.$store.getters);
    },
  },
  props: {},
  data() {
    return {
      year: '',
    };
  },
  mounted() {
    let start = 2021;
    this.year = start;
    if (new Date().getFullYear() > start) {
      this.year += '-' + new Date().getFullYear();
    }
  },
  updated() {},
  methods: {
    content(item) {
      return language(this.data.language.current)[item];
    },
  },
};
</script>
